/* eslint-disable import/no-anonymous-default-export */
export default {
  IMAGECONFIG: {
    SMALL: "http://api.skillohana.com/api/v1/media/small/",
    THUMBNAIL: "http://api.skillohana.com/api/v1/media/thumb/",
    MEDIUM: "http://api.skillohana.com/api/v1/media/medium/",
    PROFILE: "http://api.skillohana.com/api/v1/media/profile/",
    ORIGINAL: "http://api.skillohana.com/api/v1/media/original/",
    BANNER: "http://api.skillohana.com/api/v1/media/banner/",
  },
};
